import DocumentType from '@/generated/classes/DocumentType';
export default class DocumentTypeExtend extends DocumentType {
  constructor() {
    super();
  }
}
